<template >
  <div class="msp-totale-dettaglio">
    <span class="totale-item" v-if="totale.sec">

      <span class="dati-label">
        <span class="msp-icon-time" aria-hidden="true"></span>
      </span>
      <span class="dati-value">  {{secondsToHms(totale.sec)}}</span>
    </span>


    <span class="totale-item"
    v-if="hasDistance(sport_id) && totale.mt && convertDistanceFromIdSport(totale.mt,sport_id)">

    <span class="dati-label">
      <span class="msp-icon-distance" aria-hidden="true"></span>
    </span>
    <span class="dati-value">    {{convertDistanceFromIdSport(totale.mt,sport_id)}}  {{getUnitFromSport(sport_id)}}</span>

  </span>
</div>
</template>

<script>
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";

const component = {
  props: ['dettaglio','zone-attive', 'sport_id'],
  mixins: [
    allenamentoCalcoli,
  ],
  computed: {
    totale: function ()
    {
      const dettaglio = this.dettaglio;
      const zone_attive = this.zoneAttive;
      if (!(dettaglio.serie && dettaglio.serie.length) ) {
        return false;
      }
      let tot = {
        mt: 0,
        sec: 0,
      }
      const ripetute = (+dettaglio.ripetute) ? dettaglio.ripetute : 1;
      dettaglio.serie.forEach(
        (s)=>{
          if (!s.andature) {
            return;
          }
          let totale = this.MSP().sommaTotaleMtSecAndature(s.andature, zone_attive) || false;
          tot.mt += totale.mt * s.ripetute * ripetute;
          tot.sec += totale.sec * s.ripetute * ripetute;

        }
      );

      return tot;
    },


  },
  methods: {
  }
}
export default component;
</script>

<style lang="scss">
.msp-totale-dettaglio {
  display: flex;
  gap: 5px;
  padding: 0 5px;
  flex-wrap: wrap;
  .totale-item {
    display: flex;
    flex: 1;
    white-space: nowrap;
    align-items: center;
    padding: 0 3px;
    & + .totale-item {
        border-left: 1px solid #000;
    }
  }
  .dati-value {
    font-weight: normal;

  }

}

</style>
